import { FunctionComponent } from "react"
import { ErrorText } from "../common/errorText"
import Card from "./generic/Card"

import { GroupByField, SumByField, SumOfField } from "./selectorFields"

export interface IReportState {
  groupBy1: string
  groupBy2: string
  groupBy3: string
  groupBy4: string
  groupBy5: string
  sumBy: string
  sumOf: string
  sumOf2: string
}

interface IReportSelectorProps {
  hasError: any
  values?: IReportState
  multipleSumOf?: boolean
  sumByFields?: string[]
  onChange?: (name: string, value: string, isValid: boolean) => void
}

const ReportSelector: FunctionComponent<IReportSelectorProps> = ({
  values,
  hasError,
  multipleSumOf,
  sumByFields,
  onChange
}) => {
  const sumByOptions = sumByFields
    ? sumByFields.map((val) => ({ label: val, value: val }))
    : []

  return (
    <div className="report-flight">
      <Card title="Report">
        <fieldset className="d-flex ocs-mb-12 align-items-end">
          <div className="ocs-w-128 ocs-mr-4">
            <GroupByField
              caption="Group By"
              name={"groupBy1"}
              isMulti={false}
              value={values.groupBy1}
              unique={[
                values.groupBy2,
                values.groupBy3,
                values.groupBy4,
                values.groupBy5
              ]}
              onChange={onChange}
              errorMsg={ErrorText.uniqueErrorText}
              menuPortalTarget={document.body}
            />
          </div>
          <div className="ocs-w-128 ocs-mr-4">
            <GroupByField
              caption={null}
              name={"groupBy2"}
              isMulti={false}
              value={values.groupBy2}
              unique={[
                values.groupBy1,
                values.groupBy3,
                values.groupBy4,
                values.groupBy5
              ]}
              onChange={onChange}
              errorMsg={ErrorText.uniqueErrorText}
              menuPortalTarget={document.body}
            />
          </div>
          <div className="ocs-w-128 ocs-mr-4">
            <GroupByField
              caption={null}
              name={"groupBy3"}
              isMulti={false}
              value={values.groupBy3}
              unique={[
                values.groupBy1,
                values.groupBy2,
                values.groupBy4,
                values.groupBy5
              ]}
              errorMsg={ErrorText.uniqueErrorText}
              onChange={onChange}
              menuPortalTarget={document.body}
            />
          </div>
        </fieldset>
        <fieldset className="d-flex ocs-mb-12 align-items-end">
          <div className="ocs-w-128 ocs-mr-4">
            <GroupByField
              caption={null}
              name={"groupBy4"}
              isMulti={false}
              value={values.groupBy4}
              unique={[
                values.groupBy1,
                values.groupBy2,
                values.groupBy3,
                values.groupBy5
              ]}
              onChange={onChange}
              errorMsg={ErrorText.uniqueErrorText}
              menuPortalTarget={document.body}
            />
          </div>
          <div className="ocs-w-128 ocs-mr-4">
            <GroupByField
              caption={null}
              name={"groupBy5"}
              isMulti={false}
              value={values.groupBy5}
              unique={[
                values.groupBy1,
                values.groupBy2,
                values.groupBy3,
                values.groupBy4
              ]}
              onChange={onChange}
              errorMsg={ErrorText.uniqueErrorText}
              menuPortalTarget={document.body}
            />
          </div>
        </fieldset>
        <fieldset>
          <div className="d-flex  ocs-mb-12">
            <div className="ocs-w-128 ocs-mr-4">
              <SumByField
                name={"sumBy"}
                isMulti={false}
                value={values.sumBy}
                options={sumByOptions}
                hasError={hasError.find((a: string) => a === "sumBy")}
                required
                onChange={onChange}
                menuPortalTarget={document.body}
                tooltipRelative
              />
            </div>
          </div>
          <div className="d-flex  ocs-mb-12 align-items-end">
            <div className="ocs-w-128 ocs-mr-4">
              <SumOfField
                name={"sumOf"}
                isMulti={false}
                value={values.sumOf}
                required
                hasError={hasError.find((a: string) => a === "sumOf")}
                onChange={onChange}
                menuPortalTarget={document.body}
                tooltipRelative
              />
            </div>
            {multipleSumOf && (
              <div className="ocs-w-128 ocs-mr-4">
                <SumOfField
                  caption={null}
                  name={"sumOf2"}
                  isMulti={false}
                  value={values.sumOf2}
                  onChange={onChange}
                  unique={[values.sumOf]}
                  errorMsg={ErrorText.uniqueErrorText}
                  menuPortalTarget={document.body}
                  clearable
                />
              </div>
            )}
          </div>
        </fieldset>
      </Card>
    </div>
  )
}
export default ReportSelector
